<div class="flex flex-col h-full">
  <!-- Scrollable area -->
  <div>

    @if (collapsed) {
      <ng-container *ngTemplateOutlet="conversationList; context: {
      $implicit: conversationService.conversationHistory(),
      scrollHeight: 'calc(100vh - 133px - .5rem)'
    }"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="conversationList; context: {
      $implicit: conversationService.conversationHistory(),
      scrollHeight: 'calc(100vh - 170px - .5rem)'
    }"></ng-container>
    }
  </div>

  <!-- Footer -->
  <div class="flex items-center justify-center border-t-2 border-gray-200 pt-2">
    <button (click)="routeTo()">
      <i
        class="pi pi-home mr-2"
        aria-label="Return to My Clients"
        [pTooltip]="collapsed ? 'Return to My Clients' : undefined"
        tooltipPosition="top"
      ></i>
      @if (!collapsed) {Return to My Clients}
    </button>
  </div>
</div>

<!-- Shared Conversation Info List Template -->
<ng-template #conversationList let-conversations let-scrollHeight="scrollHeight">
  @if (!collapsed) {<div class="py-2 px-2 text-sm font-medium text-gray-600">Searched Conversations</div>}
  <p-scrollPanel styleClass="pb-2" [style]="{ height: scrollHeight }">
    @if (conversations.length > 0) {
      <ng-container *ngFor="let conversation of conversations; trackBy: trackByConversationId">
        <div
          [attr.data-conversation]="conversation.conversationId"
          tabindex="-1"
          style="margin-bottom: .5rem"
        >
          <lib-conversation-info
            [conversationInfo]="conversation"
            [selected]="conversation.conversationId === conversationService.activeConversation()?.conversationId"
            [collapsed]="collapsed"
            (conversationClicked)="selectConversation($event)"
          />
        </div>
      </ng-container>
    } @else if (!collapsed) {
      <div class="flex items-center justify-center">No searched conversations</div>
    }
  </p-scrollPanel>
</ng-template>
